<template>
	<div>	
		<canvas ref="drawVideo" class="overlay-canvas-draw"  @mousemove="onMouseMove" @mousedown="onMouseDown" @mouseup="onMouseUp"></canvas>
	</div>
</template>
<style scoped>
.overlay-canvas-draw {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
/*  height: 100%;*/
   flex-shrink: 0; /* Evita que el canvas cambie de tamaño dinámicamente */
  height: auto; 
  pointer-events: auto; /* Permite que los controles del video funcionen */
  z-index: 10;
}

</style>
<script type="text/javascript">
	// import DrawOnVideo from "@/components/face/DrawOnVideo.vue"
	export default{
		name : "DrawOnVideo",
		props: ["currentHeight", "refVideo", "refContent", "infoToFilter"],
		data:()=>({
			context:null,
			isDrawing: false,
	    startX: 0,
	    startY: 0,
	    endY: 0,
	    endX: 0,
	    capturedImage: null,
		}),
		mounted(){
			const video = this.refVideo;
		  const canvas = this.$refs.drawVideo;
		  canvas.width = video.offsetWidth;
		  canvas.height = video.offsetHeight;		  
			// console.log("this.$refs.drawVideo ",this.$refs.drawVideo, this.refVideo, video.offsetHeight ,video.height, canvas.height)
		},
		methods:{
			clearCaptured(){
				this.startX= 0;
		    this.startY= 0;
		    this.endY= 0;
		    this.endX= 0;
		    this.capturedImage= null;
			},
			onMouseDown(event) {
				const rect = this.$refs.drawVideo.getBoundingClientRect();
				const scaleX = this.$refs.drawVideo.offsetWidth / rect.width;
  			const scaleY = this.$refs.drawVideo.offsetHeight / rect.height;
				
				this.startX = (event.clientX - rect.left) * scaleX;
				this.startY = (event.clientY - rect.top) * scaleY;
				this.isDrawing = true;
				this.$refs.drawVideo.style.cursor = 'crosshair';
			},
			onMouseMove(event) {
				this.$refs.drawVideo.style.cursor = 'crosshair';
				
				if (!this.isDrawing) return;
				const rect = this.$refs.drawVideo.getBoundingClientRect();								
				const scaleX = this.$refs.drawVideo.offsetWidth / rect.width;
				const scaleY = this.$refs.drawVideo.offsetHeight / rect.height;
				this.endX = (event.clientX - rect.left) * scaleX;
  			this.endY = (event.clientY - rect.top) * scaleY;
				this.drawRectangle();
			},
			onMouseUp() {
				if (!this.isDrawing) return;
				this.isDrawing = false;
				this.captureImage();
				const rect = this.$refs.drawVideo.getBoundingClientRect();
				this.$refs.drawVideo.style.cursor = 'default';
			},
			drawRectangle() {
				const canvas = this.$refs.drawVideo;
				const ctx = canvas.getContext("2d");
      	ctx.clearRect(0, 0, canvas.width, canvas.height); // Limpia el canvas
      	ctx.strokeStyle = "red";
      	ctx.lineWidth = 2;
      	
      	ctx.strokeRect(
	      	this.startX,
	      	this.startY,
	      	this.endX - this.startX,
	      	this.endY - this.startY,
      	);
			},
		  captureImage() {
		  	const video = this.refVideo;
		  	if (!(video instanceof HTMLVideoElement)) {
			    console.error("video ref no es un elemento HTMLVideoElement válido.");
			    return;
				}
		  	const canvas = document.createElement("canvas");

		  	video.crossOrigin = null;

		  	const width = Math.abs(this.endX - this.startX);
		  	const height = Math.abs(this.endY - this.startY);
		  	const startX = Math.min(this.startX, this.endX);
		  	const startY = Math.min(this.startY, this.endY);

		  	canvas.width = width;
		  	canvas.height = height;

		  	const ctx = canvas.getContext("2d");
		  	
		  	const scaleX = video.videoWidth / video.offsetWidth;
  			const scaleY = video.videoHeight / video.offsetHeight;
		  	
		  	ctx.drawImage(
		  		video,
		  		startX * scaleX,
		  		startY * scaleY,
		  		width * scaleX,
		  		height * scaleY,
		  		0,
		  		0,
		  		width,
		  		height,
		  		);

			canvas.toBlob((blob) => {
				if (this.capturedImage) {
					URL.revokeObjectURL(this.capturedImage);
				}
				this.capturedImage = URL.createObjectURL(blob);
				this.$emit("captureImage", this.capturedImage);
				this.clearCaptured(); // Se limpia después de emitir
			}, "image/png");

			this.$refs.drawVideo.style.cursor = 'default';
		  },
		},
		beforeDestroy() {
			if (this.capturedImage) {
				URL.revokeObjectURL(this.capturedImage);
			}
		}
	}
</script>